export class GenOTPRequest {
    ekpayId: string = "NA";
    mobile: string = "";
    module: string = "";
    email: string = "";
    mode: string = "web";
    type: string = "mobile";
}


// WEBPACK FOOTER //
// ./src/app/shared/registeration/gen-otp-request.ts